import { acquireToken } from './auth'
import { cspAuthScopes } from '../config/OnboardingConfig'

const encodeFormBody = jsonBody =>
  Object.entries(jsonBody)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&')

export const getPartnerCenterToken = async () => {
  const access = await acquireToken(cspAuthScopes)
  const resp = await fetch('https://api.partnercenter.microsoft.com/generatetoken', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${access}`,
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: encodeFormBody({ grant_type: 'jwt_token' }),
  })
  if (!resp.ok) throw new Error('Failed to get partner center token')
  const json = await resp.json()
  return json.access_token
}

export const getCustomers = async partnerCenterToken => {
  let customers = []
  let continuationToken = null
  let url = 'https://api.partnercenter.microsoft.com/v1/customers?size=1000'
  do {
    const headers = { Authorization: `Bearer ${partnerCenterToken}` }
    if (continuationToken) headers['MS-ContinuationToken'] = continuationToken
    const target = continuationToken ? `${url}&seekOperation=Next` : url
    const resp = await fetch(target, { headers })
    const data = await resp.json()
    customers = customers.concat(data.items || [])
    continuationToken = data.continuationToken || null
  } while (continuationToken)

  return customers
}


